import React from 'react';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <h1>Make Your Interior More <br></br> Minimalistic & Modern</h1>
      <p>Turn your room with sawla stones into a lot more <br></br>minimalist and modern with ease and speed</p>
    </div>
  );
};

export default Home;
